// extracted by mini-css-extract-plugin
export default {"AccordionTitle":"AxjtSNVY","icon":"uiCPxf2t","opened":"CTs2u0nC"};